import React from 'react'
import Footer from './Footer'
import Header from './Header'


class PhotosView extends React.Component {

  state = {
    photos: {
      name: 'Photos',
      filePath: 'https://garnet-audio-downloads.s3.eu-west-2.amazonaws.com/Libya-assets/photos/libya-photo-'
    },
    files: []
  }

  photoloop = () => {
    const imageURLs = [];
    for (let i = 1; i < 87; i++) {
      let imageURL = this.state.photos.filePath + [i] + '.JPG'
      imageURLs.push(imageURL);
    }
    this.setState({ files: imageURLs })
  }

  componentDidMount() {
    this.photoloop()
  }

  render() {

    return(

      <div>
        
        <Header />

        <div className="container">

          <h1 style={{textAlign: 'center', margin: '60px 0 20px 0', color: '#816992'}}>{this.state.photos.name}</h1><p style={{textAlign: 'center'}}>Photos from our recent teacher training sessions.</p>

          <div className="image-wrapper">
            
            {this.state.files.map(file => (
                
                <div key={file} className="photo">
                  <img alt="" style={{maxWidth: '100%'}} src={file} />
                </div>

            ))}

          </div>

        </div>
        <Footer />

      </div>
    )
  }
}

export default PhotosView




// WEBPACK FOOTER //
// ./src/components/PhotosView.js